export default __webpack_public_path__ + "static/media/Cardinals.2c4e9f38.png";